import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ToastPopup from '../Popups/ToastPopup';
import { apiCall } from '../main/Apicall';
import "../css/others/template.css";
import { EditEmailTemplate, createToastMessage, ToastMessage } from "../Interfaces/Interface"
const extractPlaceholders = (text: string): string[] => {
  const regex = /{{\s*([^}]+?)\s*}}/g;
  const matches = new Set<string>();
  let match;
  while ((match = regex.exec(text)) !== null) {
    matches.add(`{{${match[1].trim()}}}`);
  }
  return Array.from(matches);
};
const escapeNewLines = (text: string) => text.replace(/\n/g, '\\n');
const EditTemplate: React.FC = () => {
  const { clientId, templateId } = useParams();
  const navigate = useNavigate();
  const username = 'Admin';
  const [template, setTemplate] = useState<EditEmailTemplate | null>(null);
  const [originalTemplate, setOriginalTemplate] = useState<EditEmailTemplate | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const data = await apiCall('get', `/api/email-templates/client/${clientId}/template/${templateId}`);
        const parsedData = { ...data, body: data.body.replace(/\\n/g, '\n') };
        setTemplate(parsedData);
        setOriginalTemplate(parsedData);
      } catch (err) {
        console.error('Failed to load template');
      }
    };
    if (templateId) {
      fetchTemplate();
    }
  }, [clientId, templateId]);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!template) return;
    const { name, value } = e.target;
    const updated = { ...template, [name]: name === 'type' ? value.toUpperCase().replace(/\s+/g, '_') : value };
    const subjectPlaceholders = name === 'subject'
      ? extractPlaceholders(value) : extractPlaceholders(updated.subject);
    const bodyPlaceholders = name === 'body'
      ? extractPlaceholders(value) : extractPlaceholders(updated.body);
    updated.placeholders = Array.from(new Set([...subjectPlaceholders, ...bodyPlaceholders]));
    setTemplate(updated);
  };
  const handleSubmit = async () => {
    if (!template?.templateId) return;
    const isAnyFieldEmpty = !template.name.trim() || !template.subject.trim() || !template.body.trim() || !template.type.trim();
    if (isAnyFieldEmpty) {
      setMessage(createToastMessage(('Please fill all fields'), "warning", 3000));
      return;
    }
    try {
      setIsLoading(true);
      const payload: EditEmailTemplate = { ...template, body: escapeNewLines(template.body), placeholders: extractPlaceholders(template.subject + '\n' + template.body) };
      await apiCall('put', `/api/email-templates/${template.templateId}?username=${username}`, payload);
      setMessage(createToastMessage('Template updated successfully!', "success", 3000));
      setTimeout(() => { window.location.reload(); }, 3000);
      setIsEditMode(false);
    } catch (err) {
      console.error('Failed to update template');
    }
  };
  const handleCancelEdit = () => { setTemplate(originalTemplate); setIsEditMode(false) };
  if (!template) return null;
  const handleBack = () => { navigate(-1); };
  return (
    <div className="template-page-container">
      <div className="template-page-header">
        <h2>Email Template Detail</h2>
      </div>
      <form className="template-page-form">
        <div className="template-page-field">
          <label>Template Name</label>
          <input name="name" value={template.name} onChange={handleInputChange} disabled={!isEditMode || isLoading} placeholder="e.g., Enter an Email Template Name" />
        </div>
        <div className="template-page-field">
          <label>Subject</label>
          <input name="subject" value={template.subject} onChange={handleInputChange} disabled={!isEditMode || isLoading} placeholder="e.g., Welcome to {{company_name}}!" />
        </div>
        <div className="template-page-field">
          <label>Body</label>
          <textarea name="body" value={template.body} rows={10} onChange={handleInputChange} disabled={!isEditMode || isLoading} placeholder={`Dear {{first_name}},\n\nWelcome to {{company_name}}! We're excited to have you on board.\n\nBest regards,\n{{company_name}} Team`} />
          {template.placeholders.length > 0 && (
            <div className="template-page-placeholders">
              <strong>Placeholders:</strong> {template.placeholders.map(p => `${p}`).join(', ')}
            </div>
          )}
        </div>
        <div className="template-page-field">
          <label>Type</label>
          <input name="type" value={template.type} onChange={handleInputChange} disabled={!isEditMode || isLoading} placeholder="e.g., user welcome (will become USER_WELCOME)" />
          <small className="small">Will be automatically converted to UPPER_CASE_WITH_UNDERSCORES</small>
        </div>
      </form>
      <div className="buttons2">
        <button type="button" onClick={handleBack} className="cancelbutton2" disabled={isLoading}>Back</button>
        {!isEditMode ? (
          <button type="button" className="cancelbutton2" onClick={() => setIsEditMode(true)}>Edit</button>
        ) : (
          <>
            <button type="button" className="cancelbutton2" onClick={handleCancelEdit} disabled={isLoading}>Cancel</button>
            <button type="button" className="savebutton2" onClick={handleSubmit} disabled={isLoading}>Update</button>
          </>
        )}
      </div>
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default EditTemplate; 